// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1t1c1","info":"Note_info__ENFA7","note":"Note_note__1B02d","actions":"Note_actions__1sjtN"};